import { render, staticRenderFns } from "./InfosetReborn.vue?vue&type=template&id=65db8d40&scoped=true&"
import script from "./InfosetReborn.vue?vue&type=script&lang=ts&"
export * from "./InfosetReborn.vue?vue&type=script&lang=ts&"
import style0 from "./InfosetReborn.vue?vue&type=style&index=0&id=65db8d40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65db8d40",
  null
  
)

export default component.exports